<template>

  <swiper
    :spaceBetween="30"
    :slidesPerView="3"
    :navigation="true"
    :pagination="true"
    :history="{
      key: 'slide',
    }"
    :modules="modules"
    class="mySwiper">
    
    <swiper-slide data-history="1" class="">
      <div class="card p-3">
        <div class="image">
          <img src="../assets/Images/service1.png" alt="" class="img-fluid">
        </div>
        <div class="body">
        <small>Training</small>
        <p class="">Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint, amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint<span class="link">...Read more</span></p>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide data-history="2">
       <div class="card p-3">
        <div class="image">
          <img src="../assets/Images/service2.png" alt="" class="img-fluid">
        </div>
        <div class="body ">
        <small>App Development</small>
        <p class="">Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint, amet minim mollit non deserunt ullamco est sit aliqua dolor do amet<span class="link">...Read more</span></p>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide data-history="3">
       <div class="card p-3">
        <div class="image">
          <img src="../assets/Images/laptop.png" alt="" class="img-fluid">
        </div>
        <div class="body ">
        <small>Business Branding</small>
        <p class="">Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint, amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint<span class="link">...Read more</span></p>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide data-history="4">
       <div class="card p-3">
        <div class="image">
          <img src="../assets/Images/service1.png" alt="" class="img-fluid">
        </div>
        <div class="body ">
        <small>Training</small>
        <p class="">Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint, amet minim mollit non deserunt ullamco est sit aliqua dolor do amet<span class="link">...Read more</span></p>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide data-history="5">
       <div class="card p-3">
        <div class="image">
          <img src="../assets/Images/service2.png" alt="" class="img-fluid">
        </div>
        <div class="body ">
        <small>App Development</small>
        <p class="">Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint, amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint<span class="link">...Read more</span></p>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide data-history="6">
       <div class="card p-3">
        <div class="image">
          <img src="../assets/Images/laptop.png" alt="" class="img-fluid">
        </div>
        <div class="body ">
        <small>Business Branding</small>
        <p class="">Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint, amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint <span class="link">...Read more</span></p>
        </div>
      </div>
    </swiper-slide>
  </swiper>
  
</template>
<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../style.css";
// import required modules
import { Navigation, Pagination, History } from "swiper";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Navigation, Pagination, History],
    };
  },
 
};
</script>


<style scoped>
.body small{
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 150%;
  letter-spacing: 0.02em;
  color: #000000;
}

.body p{
  font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 150%;
color: #595959;
}

.body span{
    color: #335CA6;
    font-weight: 600;
}

@media screen and (max-width:768px) {
  
}
</style>